import React, { useEffect } from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import TextField from "component/textField/TextField";
import LabeledSelect from "component/select/labeledSelect/LabeledSelect";
import PhoneNumberInput from "component/phoneNumberInput/PhoneNumberInput";
import AppDatePicker from "component/inputs/datePicker/DatePicker";


const maritalStatus = [{
  label: 'Single',
  value: 'single'
},{
  label: 'Married',
  value: 'married'
},{
  label: 'Divorced',
  value: 'divorce'
}]

const genders = [
  {
    label: 'Male',
    value: 'male'
  },
  {
    label: 'Female',
    value: 'female'
  }
]


function CoApplicantDetails({trigger, watch, setValue, errors, register, formData }) {
 
  const coDob = watch('coDob', '')

  useEffect(()=>{
    if(formData.coPhone){
      trigger('coPhone')
    }
  }, [formData.coPhone])


  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">Co Application Details</Typography>
            <Typography>
              Details of the individual making the application
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                     textValidation
                     setValue={setValue}
                     watch={watch}
                   required={true}
                    name="coFirstName"
                    register={register}
                    errors={errors}
                    label="First Name"
                    type="text"
                    placeholder="First Name"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                     textValidation
                     setValue={setValue}
                     watch={watch}
                   required={true}
                    name="coLastName"
                    register={register}
                    errors={errors}
                    label="Last Name"
                    type="text"
                    placeholder="Last Name"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                 textValidation
                 setValue={setValue}
                 watch={watch}
                    name="coMiddleName"
                    register={register}
                    errors={errors}
                    label="Middle Name"
                    type="text"
                    placeholder="Middle Name"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                   required={true}
                    name="coGender"
                    data={genders}
                    register={register}
                    errors={errors}
                    label="Gender"
                    placeholder="Select Gender"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  {/* <TextField
                   required={true}
                   dateMax={true}
                    name="coDob"
                    register={register}
                    errors={errors}
                    label="Date of Birth"
                    type="date"
                    placeholder="Date of Birth"
                  /> */}
                   <AppDatePicker
                    required={true}
                    errors={errors}
                    name="coDob"
                    label="Date of Birth"
                    setValue={setValue}
                    value={coDob}
                    trigger={trigger}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                   required={true}
                    name="coEmail"
                    register={register}
                    errors={errors}
                    label="Email Address"
                    type="text"
                    placeholder="Email Address"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <PhoneNumberInput
                    value={formData.coPhone}
                    name="coPhone"
                    errors={errors}
                    setValue={setValue}
                  />
                  {/* <TextField
                   required={true}
                    name="coPhone"
                    register={register}
                    errors={errors}
                    label="Phone Number"
                    type="text"
                    placeholder="Phone Number"
                  /> */}
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                   required={true}
                  data={maritalStatus}
                    name="coMaritalStatus"
                    register={register}
                    errors={errors}
                    label="Marital Status"
                    placeholder="Marital Status"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default CoApplicantDetails;